import { api, unwrap } from './client';
import { memberFromApi, memberToApi } from './_transforms';

// Backend page size cap is generous; we request a big window so the existing
// client-side filter/search keeps working without paginating the UI.
const PAGE_SIZE = 500;

export async function listMembers({ page = 0, size = PAGE_SIZE, sort = 'createdAt,desc', q, status } = {}) {
  const params = { page, size, sort };
  if (q) params.q = q;
  if (status) params.status = status.toUpperCase();
  const data = await unwrap(api.get('/api/members', { params }));
  return {
    content: (data.content || []).map(memberFromApi),
    totalElements: data.totalElements,
    totalPages: data.totalPages,
    number: data.number,
  };
}

export async function getMember(id) {
  const data = await unwrap(api.get(`/api/members/${id}`));
  return memberFromApi(data);
}

export async function createMember(payload) {
  const data = await unwrap(api.post('/api/members', memberToApi(payload)));
  return memberFromApi(data);
}

export async function updateMember(id, payload) {
  const data = await unwrap(api.put(`/api/members/${id}`, memberToApi(payload)));
  return memberFromApi(data);
}

export async function deleteMember(id) {
  return unwrap(api.delete(`/api/members/${id}`));
}
